module.exports = __webpack_public_path__ + "static/media/41-6.7110380d.mp3";